<template>
  <div id="app">
    <HeadComponent />
    <router-view />
    <FooterComponent />
  </div>
</template>

<script>
// @ is an alias to /src
import HeadComponent from '@/components/Header.vue';
import FooterComponent from '@/components/Footer.vue';

export default {
  name: 'home',
  components: {
    HeadComponent,
    FooterComponent,
  },
};
</script>

<style lang="less">
@font-face {
  font-family: "Gotham";
  src: url("./assets/fonts/Gotham-Light.eot");
  src: url("./assets/fonts/Gotham-Light.eot?#iefix") format("embedded-opentype"),
    url("./assets/fonts/Gotham-Light.woff2") format("woff2"),
    url("./assets/fonts/Gotham-Light.woff") format("woff"),
    url("./assets/fonts/Gotham-Light.ttf") format("truetype"),
    url("./assets/fonts/Gotham-Light.svg#Gotham-Light") format("svg");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "Gotham";
  src: url("./assets/fonts/Gotham-Medium.eot");
  src: url("./assets/fonts/Gotham-Medium.eot?#iefix")
      format("embedded-opentype"),
    url("./assets/fonts/Gotham-Medium.woff2") format("woff2"),
    url("./assets/fonts/Gotham-Medium.woff") format("woff"),
    url("./assets/fonts/Gotham-Medium.ttf") format("truetype"),
    url("./assets/fonts/Gotham-Medium.svg#Gotham-Medium") format("svg");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Gotham";
  src: url("./assets/fonts/Gotham-Black.eot");
  src: url("./assets/fonts/Gotham-Black.eot?#iefix") format("embedded-opentype"),
    url("./assets/fonts/Gotham-Black.woff2") format("woff2"),
    url("./assets/fonts/Gotham-Black.woff") format("woff"),
    url("./assets/fonts/Gotham-Black.ttf") format("truetype"),
    url("./assets/fonts/Gotham-Black.svg#Gotham-Black") format("svg");
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: "Gotham Book";
  src: url("./assets/fonts/Gotham-Book.eot");
  src: url("./assets/fonts/Gotham-Book.eot?#iefix") format("embedded-opentype"),
    url("./assets/fonts/Gotham-Book.woff2") format("woff2"),
    url("./assets/fonts/Gotham-Book.woff") format("woff"),
    url("./assets/fonts/Gotham-Book.ttf") format("truetype"),
    url("./assets/fonts/Gotham-Book.svg#Gotham-Book") format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Minion Pro";
  src: url("./assets/fonts/MinionPro-Bold.eot");
  src: url("./assets/fonts/MinionPro-Bold.eot?#iefix")
      format("embedded-opentype"),
    url("./assets/fonts/MinionPro-Bold.woff2") format("woff2"),
    url("./assets/fonts/MinionPro-Bold.woff") format("woff"),
    url("./assets/fonts/MinionPro-Bold.ttf") format("truetype"),
    url("./assets/fonts/MinionPro-Bold.svg#MinionPro-Bold") format("svg");
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: "Blacksword";
  src: url("./assets/fonts/Blacksword.eot");
  src: url("./assets/fonts/Blacksword.eot?#iefix") format("embedded-opentype"),
    url("./assets/fonts/Blacksword.woff2") format("woff2"),
    url("./assets/fonts/Blacksword.woff") format("woff"),
    url("./assets/fonts/Blacksword.ttf") format("truetype"),
    url("./assets/fonts/Blacksword.svg#Blacksword") format("svg");
  font-weight: normal;
  font-style: normal;
}
body {
  margin: 0px;
  padding: 0px;
  font-family: "Gotham";
  color: #272727;
}
</style>
<style>
.inner {
  max-width: 1250px;
  margin: 0 auto;
}
.home,
.deak,
.csorbics,
.suto {
  margin-top: 65px;
  z-index: 0;
  position: relative;
}
@media screen and (max-width: 1310px) {
  .inner {
    margin: 0 30px;
    max-width: 100vw;
  }
}
</style>
